import React, { useState } from "react";

import AlertModal from "../alertModal";

import { Row, Col, Stack } from "react-bootstrap";
import { Button, Typography } from "@mui/material";

export default function PostSingleActions(props) {
  const [showAlert, setShowAlert] = useState(false);

  return (
    <>
      <Stack
        direction="horizontal"
        gap="2"
        className="gx-0 w-100 d-flex justify-content-end"
      >
        <div xs="auto">
          <Button variant="outlined" onClick={() => setShowAlert(true)}>
            <Typography owner="admin" variant="button">
              Revert
            </Typography>
          </Button>
        </div>
        <div xs="auto">
          <Button
            variant="contained"
            onClick={() => window.open(props.previewRoute, "_blank")}
          >
            <Typography owner="admin" variant="button">
              Preview
            </Typography>
          </Button>
        </div>
      </Stack>
      <AlertModal
        showAlert={showAlert}
        showCaLogo={true}
        alertType={"warning"}
        alertMessageTitle={"Are you sure"}
        alertMessageBody={"Revert changes?"}
        cancelButton={true}
        cancelButtonLabel={"Cancel"}
        confirmButton={true}
        confirmButtonLabel={"Revert"}
        confirmButtonColor={"error"}
        showAlertCallback={() => setShowAlert(false)}
        onConfirm={() => props.revertChanges()}
      />
    </>
  );
}
